<template>
<ul class="accordion dp"
  data-accordion
  data-allow-all-closed="true"
  data-multi-expand="true"
  :id="`deeplinked-accordion-${accid}`">
  <template v-for="(faq,index) in faqs">
    <li 
      :class="{'accordion-item': true, 'is-active': isExpanded(index)}"
      @click.prevent="toggleAccordion(index)"
      data-accordion-item >
      <a href="#" class="accordion-title">
          <div class="row">
              <div class="small-1 column">
                <i class="fa fa-plus" v-if="!isExpanded(index)" />
                <i class="fa fa-minus" v-if="isExpanded(index)" />
              </div>
              <div class="small-11 column">
                <span>
                  {{faq.inx}}. {{ faq.docfaq_pergunta }}
                </span>
              </div>
          </div>
      </a>
      <!--<div class="accordion-content" :id="`item${index}${accid}`">
        {{ faq.docfaq_resposta }}
      </div>-->
    </li>
  </template>
</ul>
</template>

<script>
import { ref } from "vue";

export default {
  props:["faqs","accid"],
  setup (props) {
    
    const expandedItems = ref([]);

    const toggleAccordion = (index) => {
      const selector = `#item${index}${props.accid}`;
      const $content = $(selector);
      const position = expandedItems.value.indexOf(index);
      if (position > -1) {
        expandedItems.value.splice(position, 1);
        $content.slideUp(() => { });
      } else {
        expandedItems.value.push(index);
        $content.slideDown(() => { });
      }
    };

    const isExpanded = (index) => expandedItems.value.includes(index);

    return {
      toggleAccordion,
      isExpanded
    }
  }
}
</script>

<style lang="scss" scoped>
/*#region FAQ*/
.bibliotecafaq{
  background-color: #f3f3f5;
}

.dp{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  background: transparent; 
}


.dp li{
  flex: 1 0 100%;
  background: white;
  margin-bottom: 10px;
}

.dp li a{
  font-family: "Montserrat SemiBold";
  color: rgb(10,10,10);
  border: 0;
  font-size: 17px;
  line-height: 20px;
  color: #333;
  border: 0;
  padding: 1.25rem 1rem;
}
.dp li i{
  margin-right: 15px;
  padding: 4px;
  background: #1380a0c4;
  color: white;
}
.dp li i.fa-minus{
  display: none;
}
.dp li.is-active i.fa-minus{
  display: inline-block;
}
.dp li.is-active i.fa-plus{
  display: none;
}
.dp .accordion-title:before{
  display: none;
}
.dp li .accordion-content{
  font-family: "Montserrat";
  font-size: 16px;
  padding-left: 53px;
  padding-right: 53px;
  padding-bottom: 45px;
  color: #333333;
}
.phone{
  display: none;
}

.bib_botao_ver {
  font-family: "Montserrat Bold";
}

.bib_botao_ver .accordion-title {
  color: #6eb7ec !important;
}

@media (max-width : 1024px){
  .accordwrapper{
    display: none;
  }
  .accordwrapper.phone{
    display: flex;
  }
}

@media (max-width : 767px){

  .faq {
    padding-top: 0px;
  }

  .dp li a {
    font-size: 14px;
  }

  .accordion-title {
    padding: 1.25rem 1rem !important;
  }

  .dp li .accordion-content {
    font-size: 14px;
  }

  .accordwrapper {
    padding-bottom: 45px;
  }
}
/*#endregion*/
</style>